import { Roles } from 'constants/index'

export const isConferenceLive = (conference) =>
  Boolean(conference?.isActive) && !conference?.isArchived

// Admin/owner conference assignments live in the conferenceIds array; legacy docs
// may still carry only the scalar conferenceId.
export const getAssignedConferenceIds = (userData) =>
  userData?.conferenceIds?.length
    ? userData.conferenceIds
    : userData?.conferenceId
    ? [userData.conferenceId]
    : []

export const isAssignedToConference = (userData, conferenceId) =>
  Boolean(conferenceId) && getAssignedConferenceIds(userData).includes(conferenceId)

// A conference user's role and status are per-conference: the backend writes them into
// the conferenceRoles / conferenceStatus maps keyed by conference id. The doc-level
// `role` / `status` are account-level fields and only a fallback here — the backend
// never writes them when it assigns an already-existing account to a conference, so
// conference users often have no doc-level role at all, and when they do have one it
// reflects whatever they were first created as rather than their role in *this*
// conference.
export const getConferenceRole = (userData, conferenceId) =>
  userData?.conferenceRoles?.[conferenceId] ?? userData?.role ?? Roles.ADMIN

export const getConferenceStatus = (userData, conferenceId) =>
  userData?.conferenceStatus?.[conferenceId] ?? userData?.status ?? 'active'

// Account-level roles are never conference users, so they never belong in a
// conference's user list even if a doc somehow carries a conference assignment.
export const isConferenceUser = (userData) =>
  ![Roles.SUPER_ADMIN, Roles.ORGANIZER].includes(userData?.role)
